import isDefined from './isDefined';
import isNotNull from './isNotNull';

const isDefinedAndNotNull = <T>(value: T | undefined | null): value is T => isDefined(value) && isNotNull(value);
export default isDefinedAndNotNull;
